import { render, staticRenderFns } from "./newsDocument.vue?vue&type=template&id=566273e2&scoped=true"
import script from "./newsDocument.vue?vue&type=script&lang=js"
export * from "./newsDocument.vue?vue&type=script&lang=js"
import style0 from "./newsDocument.vue?vue&type=style&index=0&id=566273e2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566273e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566273e2')) {
      api.createRecord('566273e2', component.options)
    } else {
      api.reload('566273e2', component.options)
    }
    module.hot.accept("./newsDocument.vue?vue&type=template&id=566273e2&scoped=true", function () {
      api.rerender('566273e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/industryChainNew/components/newsDocument.vue"
export default component.exports